import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import TabsView from './TabsView';

function TabsContainer() {
  const [currentNav, setCurrentNav] = React.useState(false);
  const history = useHistory();
  const {pathname} = useLocation();

  React.useEffect(() => {
    const nav = ['/list', '/invitations-sent', '/invalid-organisation-documents']
      .find(uri => pathname.includes(uri)) || '/list';

    setCurrentNav(nav);
  }, [pathname]);

  function handleTabSelect(event, selected) {
    history.push(`/subcontractors${selected}`);
  }

  return (
    <TabsView
      currentNav={currentNav}
      onTabSelect={handleTabSelect}
    />
  );
}

export default TabsContainer;
